<template>
  <div>
    <Popover v-slot="{ open }" class="relative">
      <PopoverButton
        class="relative inline-flex items-center px-3 py-2 font-medium text-gray-800 capitalize border border-gray-300 rounded-md text-md border-1 hover:bg-gray-200 dark:text-gray-100 dark:hover:bg-gray-800"
        :class="{
          'text-opacity-90': open,
          'px-1.5 py-1 text-xs sm:px-2 sm:text-sm': btnSize == 'sm',
          'text-md px-3 py-2 sm:text-lg': btnSize == 'md',
          'px-4 py-3 text-lg sm:text-xl': btnSize == 'lg',
        }"
      >
        <span>Share</span>
      </PopoverButton>

      <transition
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="translate-y-1 opacity-0"
        enter-to-class="translate-y-0 opacity-100"
        leave-active-class="transition duration-150 ease-in"
        leave-from-class="translate-y-0 opacity-100"
        leave-to-class="translate-y-1 opacity-0"
      >
        <PopoverPanel class="absolute z-10 px-4 transform" :class="{ 'left-full -translate-x-1/3': popupAlign == 'left', 'right-full translate-x-1/4': popupAlign == 'right' }">
          <div class="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 dark:shadow-black">
            <div class="flex items-center p-4 space-x-4 bg-white dark:bg-gray-700">
              <template v-for="network in sharingNetworks" :key="network">
                <ShareNetwork
                  :class="[`text-${network.name} hover:text-gray-600 dark:text-white dark:hover:text-gray-300`]"
                  :network="network.name"
                  :url="shareUrl"
                  :title="shareTitle"
                  :description="shareDescription"
                  :twitter-user="'WiseryHQ'"
                >
                  <v-icon :name="network.icon" scale="1.5" />
                </ShareNetwork>
              </template>
            </div>
          </div>
        </PopoverPanel>
      </transition>
    </Popover>
  </div>
</template>

<script>
import { ShareNetwork } from "vue-social-sharing";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
import { ref } from "@vue/reactivity";
export default {
  components: {
    ShareNetwork,
    Popover,
    PopoverButton,
    PopoverPanel,
  },
  props: ["url", "title", "description", "align", "buttonSize"],
  setup(props) {
    const sharingNetworks = [
      {
        name: "twitter",
        icon: "bi-twitter",
        color: "#1da1f2",
      },
      {
        name: "email",
        icon: "co-gmail",
        color: "#d44638",
      },
      {
        name: "messenger",
        icon: "bi-messenger",
        color: "#0084ff",
      },
      {
        name: "whatsapp",
        icon: "bi-whatsapp",
        color: "#25d366",
      },
      {
        name: "facebook",
        icon: "bi-facebook",
        color: "#3b5998",
      },
      {
        name: "linkedin",
        icon: "bi-linkedin",
        color: "#0077b5",
      },

      {
        name: "reddit",
        icon: "bi-reddit",
        color: "#ff4500",
      },
    ];
    const today = new Date().toLocaleString("en-US", { month: "long", day: "numeric" });

    const shareUrl = ref(props.url || "https://wisery.io");
    const shareTitle = ref(props.title);
    const shareDescription = ref(props.description);
    const popupAlign = ref(props.align || "left");
    const btnSize = ref(props.buttonSize || "md");

    return {
      sharingNetworks,
      today,
      shareUrl,
      shareTitle,
      shareDescription,
      popupAlign,
      btnSize,
    };
  },
};
</script>
